import { ChannelType, getActiveScreen } from 'src/modules/Redux';
import { useAppSelector } from 'src/modules/Redux/store';
import ImagePage from '../../ImagePage';
import CustomerPickupScreen from '../../CustomerPickupScreen';
import { VideoPage } from '../../VideoPage';
import { MenuBoard } from '../../MenuBoard';

const useActiveScreenComponent = () => {
    const activeScreen = useAppSelector(getActiveScreen);

    if (!activeScreen) return () => <CustomerPickupScreen />;
    switch (activeScreen.channel) {
        case ChannelType.CustomerPickupScreen:
            return () => <CustomerPickupScreen />;
        case ChannelType.FullScreenGallery:
        case ChannelType.ColumnScroll:
        case ChannelType.MenuCategories:
        case ChannelType.InfiniteScrollText:
        case ChannelType.InfiniteScrollImage:
        case ChannelType.Top8Cards:
            return () => <MenuBoard />;
        case ChannelType.StaticImage:
            return () => <ImagePage />;
        case ChannelType.Video:
            return () => <VideoPage />;
    }
};

export default useActiveScreenComponent;
